/* eslint-disable no-unused-vars */

export const routes = {
    target: [
        [6.56158447265625, 46.059891147620725],
        [6.5691375732421875, 46.05679376154153],
        [6.5842437744140625, 46.05059898938315],
        [6.594886779785156, 46.04702502069337],
        [6.601066589355469, 46.0460718554722],
        [6.6089630126953125, 46.0365370783104],
        [6.6185760498046875, 46.018420689207964],
        [6.624412536621094, 46.00053696838315],
        [6.626472473144531, 45.982885915835965],
        [6.62750244140625, 45.97215142749934],
        [6.62750244140625, 45.96833350337328],
        [6.630592346191406, 45.96045733860464],
        [6.636772155761719, 45.94852293319342],
        [6.6391754150390625, 45.939451769364496],
        [6.6378021240234375, 45.93324384711787],
        [6.63848876953125, 45.92488544547274],
        [6.6412353515625, 45.914376564429105],
        [6.642608642578125, 45.903148752739945],
        [6.642608642578125, 45.89120201040525],
        [6.636772155761719, 45.87925269776262],
        [6.625099182128906, 45.86730081481204],
        [6.619176864624023, 45.86138464547474],
        [6.61900520324707, 45.86150418975072],
        [6.61625862121582, 45.86000980276357],
        [6.610937118530273, 45.8569014845133],
        [6.606988906860352, 45.85397234747452],
        [6.604413986206055, 45.85122239164721],
        [6.6007232666015625, 45.848651670237814],
        [6.595916748046874, 45.84626018324633],
        [6.5923118591308585, 45.843928388195685],
        [6.589908599853516, 45.841656285085875],
        [6.591367721557617, 45.83824785204328],
        [6.596689224243163, 45.83370308906791],
        [6.600637435913085, 45.82927758273395],
        [6.603212356567383, 45.824971333041404],
        [6.610078811645508, 45.81922892648646],
        [6.621236801147461, 45.81205036306912],
        [6.62501335144043, 45.80612755201333],
        [6.621408462524414, 45.8014604933191],
        [6.617460250854492, 45.7978702862262],
        [6.613168716430663, 45.795356930734634],
        [6.608018875122069, 45.79122742102916],
        [6.602010726928711, 45.78548175710981],
        [6.596689224243164, 45.7797355009297],
        [6.59205436706543, 45.77398865248884],
        [6.579866409301758, 45.768959771428094],
        [6.560125350952148, 45.76464885774745],
        [6.547079086303711, 45.7614754304816],
        [6.540727615356445, 45.75943948963056],
        [6.538324356079102, 45.757822678368825],
        [6.53986930847168, 45.75662499669638],
        [6.5430450439453125, 45.7559662703627],
        [6.5478515625, 45.75584649936776],
        [6.553001403808594, 45.754828410949976],
        [6.558494567871094, 45.75291200510935],
        [6.562957763671875, 45.75129499950718],
        [6.5663909912109375, 45.74997739414348],
        [6.571197509765625, 45.74937848389985],
        [6.5773773193359375, 45.74949826877629],
        [6.581754684448242, 45.74937848312866],
        [6.584329605102539, 45.749019126956945],
        [6.586904525756836, 45.750037259075754],
        [6.589479446411133, 45.75243287948507],
        [6.590766906738281, 45.75261255757093],
        [6.590766906738281, 45.750576293333324],
        [6.589994430541992, 45.748420160930024],
        [6.588449478149413, 45.74614416036103],
        [6.586732864379882, 45.744347275390595],
        [6.584844589233398, 45.7430295060187],
        [6.582527160644531, 45.741292379297555],
        [6.57978057861328, 45.739135895227136],
        [6.577806472778319, 45.737218962914596],
        [6.576604843139648, 45.735541582359936],
        [6.575403213500977, 45.73416370744056],
        [6.574201583862305, 45.73308533815646],
        [6.573600769042969, 45.73110822600263],
        [6.573600769042969, 45.728232370979086],
        [6.5746307373046875, 45.7267345266076],
        [6.576690673828125, 45.726614692888205],
        [6.577892303466797, 45.72577583345888],
        [6.578235626220702, 45.724217948319634],
        [6.579179763793944, 45.722420322990324],
        [6.580724716186523, 45.72038295747093],
        [6.580295562744141, 45.718765014853695],
        [6.577892303466797, 45.717566495138634],
        [6.577205657958984, 45.71618815903388],
        [6.578235626220703, 45.71463000653943],
        [6.576862335205078, 45.7129519421753],
        [6.573085784912109, 45.71115396594149],
        [6.571025848388672, 45.70833694318826],
        [6.570682525634766, 45.704500873915585],
        [6.569738388061523, 45.70156377630656],
        [6.568193435668945, 45.69952565036115],
        [6.567592620849609, 45.69694787678283],
        [6.567935943603516, 45.693830455571586],
        [6.568536758422852, 45.690772820880724],
        [6.569395065307617, 45.68777497271026],
        [6.570596694946289, 45.68573639662117],
        [6.572141647338867, 45.68465709261345],
        [6.576261520385742, 45.685136765802106],
        [6.582956314086914, 45.687175416187145],
        [6.587419509887695, 45.68843457180408],
        [6.589651107788086, 45.68891423265294],
        [6.592226028442383, 45.68915406307737],
        [6.595144271850586, 45.68915406307737],
        [6.597461700439453, 45.68915406307737],
        [6.599178314208984, 45.68915406307737],
        [6.601152420043945, 45.688554479303924],
        [6.603384017944336, 45.68735531175702],
        [6.605701446533203, 45.68639596537969],
        [6.608104705810547, 45.68567644017191],
        [6.610422134399414, 45.68483697969969],
        [6.612653732299805, 45.68387758396304],
        [6.61402702331543, 45.68309806657188],
        [6.614542007446289, 45.68249842752623],
        [6.615400314331055, 45.682918164060794],
        [6.616601943969727, 45.68435727617558],
        [6.619777679443359, 45.68615609690748],
        [6.624927520751953, 45.68831462625649],
        [6.628875732421875, 45.69059297621262],
        [6.631622314453124, 45.69299114677586],
        [6.635141372680663, 45.69556905300627],
        [6.639432907104492, 45.698326694903834],
        [6.642780303955078, 45.69970551585262],
        [6.645183563232422, 45.69970551585262],
        [6.647243499755859, 45.69982540689949],
        [6.648960113525391, 45.700065188993236],
        [6.651191711425781, 45.69982540381456],
        [6.653938293457031, 45.69910605136346],
        [6.655483245849609, 45.69808694468768],
        [6.655826568603516, 45.69676808378724],
        [6.655483245849609, 45.695209379865645],
        [6.65445327758789, 45.693410832922886],
        [6.654968261718749, 45.69263146592304],
        [6.6570281982421875, 45.69287127886611],
        [6.658916473388672, 45.69359070227061],
        [6.660633087158203, 45.694789736136556],
        [6.662349700927734, 45.695149449381276],
        [6.664066314697266, 45.69466984200477],
        [6.666126251220703, 45.69401037196457],
        [6.668529510498047, 45.693171039260676],
        [6.671104431152344, 45.692391648866725],
        [6.673851013183594, 45.691672200782705],
        [6.67668342590332, 45.69197196374806],
        [6.679601669311523, 45.6932909377628],
        [6.680631637573242, 45.69317102769216],
        [6.679773330688477, 45.69161223353616],
        [6.6803741455078125, 45.691012701178494],
        [6.68243408203125, 45.69137243061915],
        [6.684107780456543, 45.69128249739134],
        [6.6853952407836905, 45.69074290149506],
        [6.6867685317993155, 45.69059301438878],
        [6.688227653503417, 45.69083283607253],
        [6.689772605895995, 45.69104267937097],
        [6.691403388977051, 45.691222544284116],
        [6.6927337646484375, 45.691912011669146],
        [6.693763732910156, 45.69311108152605],
        [6.694836616516113, 45.69368064031863],
        [6.695952415466309, 45.693620688046906],
        [6.697282791137695, 45.693410853746215],
        [6.698827743530273, 45.693051137416546],
        [6.70015811920166, 45.69263146476619],
        [6.7012739181518555, 45.69215183579513],
        [6.702775955200195, 45.692301717759825],
        [6.70466423034668, 45.693081110660295],
        [6.707067489624023, 45.693500783310654],
        [6.709985733032226, 45.69356073571091],
        [6.7125606536865225, 45.69386049482009],
        [6.714792251586914, 45.694400060638195],
        [6.715908050537109, 45.69496959622947],
        [6.715908050537109, 45.695569101593925],
        [6.716251373291016, 45.695868854276156],
        [6.716938018798827, 45.695868854276156],
        [6.718010902404784, 45.696168600531436],
        [6.719470024108886, 45.696768093042024],
        [6.720671653747558, 45.697217710014854],
        [6.721615791320801, 45.69751745144994],
        [6.722688674926758, 45.69781719127829],
        [6.72389030456543, 45.6981169294999],
        [6.724491119384766, 45.69793708444604],
        [6.724491119384766, 45.6972776561167],
        [6.724104881286621, 45.69679806930641],
        [6.723332405090332, 45.69649832401518],
        [6.723718643188477, 45.69637842602722],
        [6.725263595581054, 45.69643837534255],
        [6.726036071777343, 45.69616860053145],
        [6.726036071777343, 45.695569101593925],
        [6.725478172302245, 45.695299327361255],
        [6.724362373352051, 45.69535927783344],
        [6.723418235778809, 45.695299327168456],
        [6.7226457595825195, 45.69511947536629],
        [6.722688674926758, 45.6947897442345],
        [6.723546981811523, 45.69431013377307],
        [6.724963188171387, 45.69395042438453],
        [6.726937294006348, 45.69371061606887],
        [6.72886848449707, 45.69356073571091],
        [6.730756759643555, 45.693500783310654],
        [6.732172966003418, 45.69155219662118],
        [6.73311710357666, 45.687714975642486],
        [6.7342329025268555, 45.68567644325687],
        [6.735520362854004, 45.6854365994643],
        [6.736550331115723, 45.68477701630928],
        [6.737322807312011, 45.683697693791814],
        [6.738438606262206, 45.68270829891062],
        [6.739897727966308, 45.68180883166569],
        [6.740756034851073, 45.68099930073348],
        [6.741013526916503, 45.68027970611398],
        [6.741957664489745, 45.67932022605483],
        [6.743588447570801, 45.67812086055603],
        [6.745090484619141, 45.67722132679136],
        [6.746463775634766, 45.67662162476083],
        [6.747708320617676, 45.67614186005142],
        [6.74882411956787, 45.67578203266314],
        [6.749811172485351, 45.67518231135147],
        [6.750669479370117, 45.67434269611642],
        [6.751656532287598, 45.673922888498886],
        [6.752772331237792, 45.673922888498886],
        [6.754274368286132, 45.6734730806441],
        [6.756162643432617, 45.672573464934516],
        [6.7572784423828125, 45.67179378879551],
        [6.757621765136719, 45.671134052227075],
        [6.758050918579102, 45.67053428592594],
        [6.758565902709961, 45.669994489892126],
        [6.759166717529297, 45.67008445474089],
        [6.759853363037109, 45.67080418047223],
        [6.761870384216309, 45.67113405511926],
        [6.7652177810668945, 45.67107407868196],
        [6.767449378967285, 45.671014102180386],
        [6.7685651779174805, 45.67095412561454],
        [6.769294738769531, 45.67086416057297],
        [6.7696380615234375, 45.670744207055655],
        [6.770153045654297, 45.67062425328127],
        [6.770839691162109, 45.6705042992498],
        [6.772127151489258, 45.670324367431334],
        [6.774015426635742, 45.670084457825894],
        [6.774015426635742, 45.66996450302317],
        [6.772127151489258, 45.66996450302317],
        [6.771955490112305, 45.66978456889096],
        [6.773500442504882, 45.66942470062655],
        [6.773715019226073, 45.66924476649434],
        [6.772599220275879, 45.66924476649434],
        [6.773114204406738, 45.66909481961671],
        [6.775259971618652, 45.668794925861455],
        [6.775174140930176, 45.66849503049943],
        [6.772856712341309, 45.66819513353063],
        [6.772556304931641, 45.66804518504624],
        [6.774272918701172, 45.66804518504624],
        [6.774358749389648, 45.6678352544687],
        [6.77281379699707, 45.66741539331363],
        [6.772599220275879, 45.66711549152453],
        [6.773715019226073, 45.66693554910137],
        [6.774702072143554, 45.66672561537457],
        [6.77556037902832, 45.6664856903441],
        [6.775646209716797, 45.66621577323874],
        [6.774959564208984, 45.66591586405846],
        [6.775345802307129, 45.66537602001425],
        [6.7768049240112305, 45.66459624110612],
        [6.778478622436523, 45.66345653371158],
        [6.780366897583008, 45.661956897830656],
        [6.781654357910156, 45.66060719661576],
        [6.782341003417969, 45.65940743006689],
        [6.783499717712402, 45.65790767367725],
        [6.785130500793456, 45.65610792744681],
        [6.786375045776366, 45.65412813023869],
        [6.787233352661133, 45.65196828205288],
        [6.787405014038086, 45.65025836377245],
        [6.786890029907227, 45.64899837539742],
        [6.786460876464844, 45.64770835689855],
        [6.786117553710937, 45.646388308275824],
        [6.7859458923339835, 45.644948215127094],
        [6.7859458923339835, 45.643388077452364],
        [6.7856454849243155, 45.64197792129724],
        [6.7850446701049805, 45.64071774666172],
        [6.7847442626953125, 45.63930751196587],
        [6.7847442626953125, 45.63774721720968],
        [6.784915924072266, 45.636486957541806],
        [6.785259246826172, 45.63552673296226],
        [6.785216331481934, 45.634296412280015],
        [6.784787178039551, 45.63279599549506],
        [6.784486770629883, 45.631505612186444],
        [6.78431510925293, 45.63042526235416],
        [6.783843040466309, 45.62961499217081],
        [6.7830705642700195, 45.629074801636385],
        [6.782126426696777, 45.628504594410785],
        [6.781010627746582, 45.62790437049401],
        [6.779894828796387, 45.62709405345571],
        [6.778779029846191, 45.626073643295896],
        [6.77830696105957, 45.62511324183759],
        [6.778478622436523, 45.624212849080784],
        [6.779379844665527, 45.623522542054104],
        [6.781010627746582, 45.62304232075755],
        [6.782641410827637, 45.6236725916381],
        [6.784272193908691, 45.625413354695766],
        [6.785774230957031, 45.62628373622459],
        [6.787147521972656, 45.62628373622459],
        [6.78980827331543, 45.625863558786946],
        [6.793756484985351, 45.62502320391164],
        [6.796374320983886, 45.62424286435796],
        [6.797661781311035, 45.62352254012592],
        [6.799807548522949, 45.622381995007544],
        [6.802811622619629, 45.62082122900286],
        [6.805686950683594, 45.619560588710925],
        [6.808433532714843, 45.61860007413175],
        [6.812295913696288, 45.61763954309858],
        [6.81727409362793, 45.61667899561142],
        [6.821565628051758, 45.61529816424987],
        [6.825170516967773, 45.613497049013944],
        [6.827831268310547, 45.61157578949916],
        [6.829547882080078, 45.609534385705544],
        [6.832122802734375, 45.6078531900475],
        [6.8355560302734375, 45.60653220252504],
        [6.8389892578125, 45.605631521501394],
        [6.8424224853515625, 45.60515114697656],
        [6.846714019775391, 45.603770014042084],
        [6.851863861083984, 45.60148812269796],
        [6.856069564819336, 45.59944636488295],
        [6.859331130981444, 45.59764474059707],
        [6.864137649536132, 45.59536257081649],
        [6.8704891204833975, 45.5925998555412],
        [6.875467300415038, 45.58947659224702],
        [6.879072189331055, 45.58599278093392],
        [6.881904602050781, 45.585392148235414],
        [6.883964538574219, 45.58767469415148],
        [6.8849945068359375, 45.58677362362409],
        [6.8849945068359375, 45.58268893665325],
        [6.884222030639648, 45.579925695095596],
        [6.88267707824707, 45.57848389895115],
        [6.883363723754883, 45.5757803402824],
        [6.886281967163086, 45.57181501908935],
        [6.889028549194336, 45.56766913670228],
        [6.891603469848633, 45.563342693121186],
        [6.894264221191406, 45.56045832335454],
        [6.897010803222656, 45.559016027402336],
        [6.898984909057617, 45.557393392392385],
        [6.900186538696289, 45.555590418324684],
        [6.901044845581055, 45.55354696466958],
        [6.901559829711914, 45.551263031427084],
        [6.902933120727539, 45.54945988381313],
        [6.905164718627929, 45.54813752182771],
        [6.906967163085937, 45.54597354106264],
        [6.9083404541015625, 45.54296794151787],
        [6.909799575805664, 45.54020266575374],
        [6.911344528198242, 45.537677713770236],
        [6.912546157836914, 45.536355117045915],
        [6.91340446472168, 45.53623487558079],
        [6.914520263671875, 45.53515266305706],
        [6.915893554687499, 45.53310847947476],
        [6.915721893310546, 45.53100409185651],
        [6.914005279541015, 45.528839500202295],
        [6.913146972656249, 45.5264342852359],
        [6.913146972656249, 45.523788446957305],
        [6.913747787475585, 45.521383046871435],
        [6.914949417114257, 45.519218084978306],
        [6.915464401245116, 45.5174139037873],
        [6.915292739868164, 45.51597050329842],
        [6.915979385375977, 45.51410603528079],
        [6.917524337768555, 45.51182049973442],
        [6.918683052062988, 45.51016646369687],
        [6.919455528259277, 45.50914392716814],
        [6.919970512390137, 45.508211600502406],
        [6.920228004455566, 45.50736948369964],
        [6.920871734619141, 45.50613634851753],
        [6.9219017028808585, 45.50451219495609],
        [6.921944618225097, 45.5038505062997],
        [6.9210004806518555, 45.504151282548364],
        [6.920528411865234, 45.504151282548364],
        [6.920528411865234, 45.5038505062997],
        [6.921086311340332, 45.50324894416059],
        [6.922202110290527, 45.50234659613102],
        [6.922760009765625, 45.50159463140491],
        [6.922760009765625, 45.50099304998224],
        [6.921558380126953, 45.50117352132368],
        [6.919155120849609, 45.50213604542921],
        [6.919112205505371, 45.50177508809083],
        [6.921429634094238, 45.50009064930855],
        [6.922802925109863, 45.49915818913655],
        [6.923232078552246, 45.49897770757483],
        [6.923360824584961, 45.49864682188341],
        [6.923189163208008, 45.4981655320623],
        [6.923789978027344, 45.49726309243573],
        [6.925163269042968, 45.49593950300371],
        [6.92610740661621, 45.49521754358901],
        [6.92662239074707, 45.49509721419162],
        [6.926836967468262, 45.49437522083771],
        [6.926751136779785, 45.49305156352729],
        [6.926321983337402, 45.492540153207386],
        [6.925549507141113, 45.492840989878005],
        [6.926021575927734, 45.491186282129306],
        [6.927738189697266, 45.48757602996128],
        [6.92812442779541, 45.4851089663334],
        [6.927180290222168, 45.48378509124565],
        [6.926107406616211, 45.482581545298075],
        [6.924905776977539, 45.48149832849069],
        [6.924347877502441, 45.480565545509805],
        [6.924433708190918, 45.47978319635544],
        [6.92413330078125, 45.47909111086522],
        [6.9234466552734375, 45.47848928903914],
        [6.922287940979004, 45.47794764476755],
        [6.920657157897949, 45.47746617805046],
        [6.919369697570801, 45.47707498425373],
        [6.918425559997559, 45.47677406337738],
        [6.917910575866699, 45.476503233431636],
        [6.917824745178223, 45.4762624944165],
        [6.917095184326172, 45.47605184710332],
        [6.915721893310547, 45.47587129149208],
        [6.9141340255737305, 45.475149052848735],
        [6.912331581115723, 45.47388513117326],
        [6.910872459411621, 45.47271146705532],
        [6.909756660461426, 45.471628060494915],
        [6.908726692199707, 45.47057472943796],
        [6.907782554626464, 45.46955147388448],
        [6.907310485839843, 45.469039846107734]
    ],
    camera: [
        [6.559867858886718, 46.05965291336496],
        [6.566820144653319, 46.05607892925637],
        [6.5807247161865225, 46.048930961039204],
        [6.59076690673828, 46.040947789076256],
        [6.596946716308594, 46.03212941336754],
        [6.600122451782227, 46.02581311383427],
        [6.60029411315918, 46.021998890476425],
        [6.599607467651367, 46.01842284020647],
        [6.598062515258789, 46.0150849630244],
        [6.597375869750977, 46.01019678816739],
        [6.59754753112793, 46.003758315635444],
        [6.598749160766602, 45.9970209089724],
        [6.600980758666992, 45.989984568178265],
        [6.602354049682617, 45.98235079239879],
        [6.602869033813477, 45.97411958163397],
        [6.605186462402344, 45.96779655343573],
        [6.609306335449219, 45.963381707804075],
        [6.614198684692383, 45.958847161133036],
        [6.619863510131835, 45.954192913422624],
        [6.6287899017333975, 45.94625521779012],
        [6.640977859497069, 45.93503407423551],
        [6.649303436279296, 45.92667707590821],
        [6.653766632080078, 45.92118422280822],
        [6.658658981323242, 45.91598943593573],
        [6.663980484008789, 45.911092715290735],
        [6.6680145263671875, 45.90368659556627],
        [6.6707611083984375, 45.893771076762334],
        [6.67119026184082, 45.886303896938024],
        [6.669301986694336, 45.88128505609335],
        [6.664924621582031, 45.87632552601306],
        [6.658058166503906, 45.87142530669717],
        [6.648960113525391, 45.8658671193758],
        [6.6376304626464835, 45.85965096404896],
        [6.628875732421874, 45.85403200857125],
        [6.6226959228515625, 45.84901025294267],
        [6.615400314331055, 45.84458602102845],
        [6.606988906860351, 45.84075931282859],
        [6.599435806274413, 45.839324321929716],
        [6.592741012573242, 45.840281048331846],
        [6.591796875, 45.83836743101954],
        [6.5966033935546875, 45.833583469992796],
        [6.600551605224609, 45.82897854134357],
        [6.603641510009765, 45.82455264507184],
        [6.61050796508789, 45.81869055466542],
        [6.621150970458984, 45.81139227012433],
        [6.624670028686523, 45.80523004766626],
        [6.621065139770508, 45.80020388729121],
        [6.614284515380859, 45.79481816022415],
        [6.604328155517577, 45.78907286646508],
        [6.598062515258788, 45.784105207861344],
        [6.595487594604492, 45.77991518441295],
        [6.592912673950195, 45.77620380562916],
        [6.590337753295898, 45.77297107150998],
        [6.579523086547852, 45.76913937856457],
        [6.560468673706055, 45.76470872679294],
        [6.547679901123047, 45.76141554755477],
        [6.541156768798828, 45.75925984085004],
        [6.537723541259766, 45.75728371274751],
        [6.537380218505859, 45.75548716324716],
        [6.539182662963867, 45.75387022705243],
        [6.543130874633789, 45.75243290416333],
        [6.548452377319336, 45.7510554372092],
        [6.555147171020508, 45.74973782619005],
        [6.561498641967773, 45.7481207025949],
        [6.567506790161133, 45.74620406642376],
        [6.573858261108398, 45.74716231870053],
        [6.58055305480957, 45.75099545942522],
        [6.585788726806641, 45.75398998493712],
        [6.589565277099609, 45.75614589523623],
        [6.59205436706543, 45.75536732027412],
        [6.593255996704102, 45.75165426005081],
        [6.593255996704102, 45.748240449682626],
        [6.59205436706543, 45.74512588916956],
        [6.587419509887695, 45.742071060170815],
        [6.579351425170898, 45.73907596268637],
        [6.573858261108398, 45.73578114337202],
        [6.570940017700195, 45.732186602227785],
        [6.569995880126953, 45.72925094062734],
        [6.571025848388671, 45.72697415857067],
        [6.572742462158202, 45.724277818906415],
        [6.575145721435547, 45.72116192163456],
        [6.575918197631836, 45.71810578158041],
        [6.57505989074707, 45.715109398743984],
        [6.572742462158203, 45.712292665970615],
        [6.568965911865234, 45.70965558326032],
        [6.566734313964844, 45.70593937521336],
        [6.56604766845703, 45.70114404182972],
        [6.565790176391601, 45.69520906597291],
        [6.565961837768555, 45.68813444764293],
        [6.569309234619141, 45.68435728851545],
        [6.575832366943359, 45.68387758859047],
        [6.580982208251953, 45.68441723596688],
        [6.584758758544921, 45.68597623064468],
        [6.588449478149413, 45.68729535453653],
        [6.59205436706543, 45.688374607642466],
        [6.595916748046875, 45.68921401772707],
        [6.60003662109375, 45.68981358479036],
        [6.605100631713867, 45.69125248712831],
        [6.611108779907227, 45.69353072474093],
        [6.617546081542969, 45.695389239187335],
        [6.624412536621094, 45.69682803046751],
        [6.6309356689453125, 45.69850656270907],
        [6.637115478515625, 45.70042483591203],
        [6.642007827758789, 45.701383972513504],
        [6.645612716674805, 45.701383972513504],
        [6.649560928344727, 45.70120413941373],
        [6.653852462768555, 45.700844473214175],
        [6.65797233581543, 45.699825388389954],
        [6.661920547485352, 45.69814688494105],
        [6.6652679443359375, 45.69682803817983],
        [6.6680145263671875, 45.6958688481063],
        [6.670503616333008, 45.69538925306953],
        [6.672735214233398, 45.69538925306953],
        [6.675052642822266, 45.6955691031364],
        [6.677455902099609, 45.69592880327014],
        [6.686124801635742, 45.696348449827084],
        [6.701059341430663, 45.69682804280723],
        [6.712388992309569, 45.697787204088115],
        [6.720113754272461, 45.69922593366971],
        [6.724491119384766, 45.69922593366971],
        [6.7255210876464835, 45.697787204088115],
        [6.725435256958007, 45.696588242203916],
        [6.724233627319335, 45.695629048017125],
        [6.725692749023437, 45.69460988452721],
        [6.729812622070312, 45.693530751734166],
        [6.732730865478515, 45.69101259706147],
        [6.734447479248046, 45.68705542050914],
        [6.738309860229491, 45.68279811105327],
        [6.744318008422852, 45.67824066869385],
        [6.7504119873046875, 45.67458254119413],
        [6.756591796874999, 45.67182372855409],
        [6.762943267822265, 45.67014443329913],
        [6.769466400146484, 45.66954465542927],
        [6.77332878112793, 45.66834506112699],
        [6.774530410766602, 45.666545650392294],
        [6.777534484863281, 45.66390635062825],
        [6.782341003417969, 45.66042716183486],
        [6.785259246826172, 45.657127747266344],
        [6.786289215087891, 45.65400810692269],
        [6.7861175537109375, 45.646807486922654],
        [6.7847442626953125, 45.635525887266226],
        [6.782426834106445, 45.62916482182298],
        [6.779165267944336, 45.62772429059292],
        [6.7765045166015625, 45.62622369545082],
        [6.774444580078125, 45.62466303639669],
        [6.774444580078125, 45.62304230340381],
        [6.7765045166015625, 45.621361496472176],
        [6.7792510986328125, 45.62088127209051],
        [6.782684326171875, 45.6216016302588],
        [6.785087585449219, 45.62268213974522],
        [6.786460876464844, 45.62412280054977],
        [6.7888641357421875, 45.62526330659004],
        [6.79229736328125, 45.62610365786605],
        [6.795473098754883, 45.62628373468203],
        [6.798391342163086, 45.625803537038],
        [6.801824569702148, 45.62466303099773],
        [6.80577278137207, 45.62286221656121],
        [6.812124252319336, 45.620641107452634],
        [6.820878982543945, 45.617999703672005],
        [6.827402114868164, 45.615178053136304],
        [6.831693649291992, 45.61217615584553],
        [6.837530136108398, 45.60899395395269],
        [6.844911575317383, 45.60563144745778],
        [6.85272216796875, 45.602088571571635],
        [6.8609619140625, 45.59836532629423],
        [6.868686676025391, 45.59554276949589],
        [6.875896453857421, 45.59362090117663],
        [6.88216209411621, 45.59193922320471],
        [6.887483596801758, 45.59049773558016],
        [6.890316009521484, 45.58785482727053],
        [6.890659332275391, 45.58401049827583],
        [6.891689300537109, 45.57944492772232],
        [6.893405914306641, 45.57415811560999],
        [6.895895004272461, 45.56953182836331],
        [6.89915657043457, 45.56556606598229],
        [6.903018951416016, 45.56147982303008],
        [6.907482147216796, 45.557273099506716],
        [6.911087036132812, 45.55264528789161],
        [6.9138336181640625, 45.54759638818477],
        [6.916494369506836, 45.54218629743325],
        [6.919069290161133, 45.53641501563702],
        [6.920270919799805, 45.53052286888634],
        [6.920099258422852, 45.52450985718119],
        [6.919240951538086, 45.51903753688923],
        [6.917695999145508, 45.51410590801048],
        [6.916751861572266, 45.51055740436378],
        [6.916408538818359, 45.50839202594914],
        [6.916666030883789, 45.506286720443725],
        [6.917524337768555, 45.50424148784753],
        [6.918468475341797, 45.502376661157285],
        [6.919498443603516, 45.500692240373006],
        [6.920957565307617, 45.4983459575087],
        [6.922845840454102, 45.49533781256436],
        [6.924047470092773, 45.492269334253635],
        [6.924562454223632, 45.48914052257654],
        [6.924476623535155, 45.4861920743804],
        [6.923789978027344, 45.48342398966521],
        [6.922588348388672, 45.48107705501224],
        [6.920871734619141, 45.479151270421475],
        [6.918468475341797, 45.47752635149105],
        [6.915378570556641, 45.47620229822097],
        [6.912202835083008, 45.47397535768372],
        [6.9089412689208975, 45.47084552987931],
        [6.907310485839843, 45.469280615977105]
    ]
};

